import { render, staticRenderFns } from "./contraryNature.vue?vue&type=template&id=227d4884&"
import script from "./contraryNature.vue?vue&type=script&lang=js&"
export * from "./contraryNature.vue?vue&type=script&lang=js&"
import style0 from "./contraryNature.vue?vue&type=style&index=0&id=227d4884&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports